module.exports = __webpack_public_path__ + "img/yktbg.4f310d8d.png";